import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getSearchAll = createAsyncThunk(
  "master/getAllSearch",
  async (credentials) => {
    const response = await AxiosInstance.get(API_ENDPOINTS.SEARCH_ALL, {
      params: credentials,
    });
    return response.data;
  }
);

const searchAllSlice = createSlice({
  name: "getSearchAll",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getSearchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getSearchAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default searchAllSlice.reducer;
